export default __webpack_public_path__ + "assets/images/button-phone-call.a14c2886406ac74d1808a1b9668d0bc7.svg";